import React from "react";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import KuikaSpinnerSmall from "../../../ui-kit/kuika-spinner-small/kuika-spinner-small";
import KuikaSvg from "../../../ui-kit/kuika-svg/kuika-svg";
import "./chatbot-window.scss";

interface IChatbotWindowProps {
  isChatbotPanelVisible: boolean;
  setIsChatbotPanelVisible: (isChatbotPanelVisible: boolean) => void;
}

interface IChatbotWindowState {
  isFrameLoading: boolean;
}

class ChatbotWindow extends React.Component<IChatbotWindowProps & IWithSDProps, IChatbotWindowState> {
  constructor(props) {
    super(props);
    this.state = { isFrameLoading: true };
  }

  handleClose = () => {
    this.props.setIsChatbotPanelVisible(false);
  };

  render() {
    return (
      this.props.isChatbotPanelVisible && (
        <div className="kuika-chatbot-window">
          <div style={{ position: "relative", width: "100%", height: "100%" }}>
            <div
              style={{
                padding: "8px",
                zIndex: 1001,
                height: "32px",
                width: 400,
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end"
              }}
            >
              <KuikaSvg name="x" width={20} height={20} pointer onClick={this.handleClose} />
            </div>
            <iframe
              className="kuika_chatbot_iframe"
              src="https://www.chatbase.co/chatbot-iframe/oMdK6zTAPAb36LA36id0d"
              frameBorder="0"
              onLoad={() => this.setState({ isFrameLoading: false })}
              onError={() => this.setState({ isFrameLoading: false })}
            />
            {this.state.isFrameLoading && (
              <div className="kuika-chatbot-window__loading">
                <KuikaSpinnerSmall size="default" />
              </div>
            )}
            <div className="kuika-chatbot-window__footer">
              <img src="/images/common/ai-bot.svg" alt="AI" />
              <div className="kuika-chatbot-window__footer-label">Kuika AI Assistant</div>
            </div>
          </div>
        </div>
      )
    );
  }
}

const chatbotWindow = withSD<IChatbotWindowProps>(ChatbotWindow);
export { chatbotWindow as ChatbotWindow };
